var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarDollarBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:dollar-bold",
    clipPath: "url(#clip0_14_8771)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 101",
    cx: 20,
    cy: 20,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4999 11.6934C16.628 12.2053 15.5 13.6433 15.5 14.9993C15.5 16.3552 16.628 17.7932 18.4999 18.3031V11.6934ZM21.4998 21.695V28.3028C23.3717 27.7928 24.4997 26.3549 24.4997 24.9989C24.4997 23.643 23.3717 22.205 21.4998 21.695Z",
    fill: "#15EFE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9987 19.9993C39.9987 31.045 31.045 39.9987 19.9993 39.9987C8.95371 39.9987 0 31.045 0 19.9993C0 8.95371 8.95371 0 19.9993 0C31.045 0 39.9987 8.95371 39.9987 19.9993ZM19.9993 6.49979C20.3972 6.49979 20.7787 6.65782 21.06 6.93911C21.3413 7.22041 21.4993 7.60193 21.4993 7.99974V8.63372C24.7592 9.2177 27.4991 11.6676 27.4991 14.9995C27.4991 15.3973 27.3411 15.7788 27.0598 16.0601C26.7785 16.3414 26.397 16.4995 25.9992 16.4995C25.6013 16.4995 25.2198 16.3414 24.9385 16.0601C24.6572 15.7788 24.4992 15.3973 24.4992 14.9995C24.4992 13.6436 23.3712 12.2056 21.4993 11.6936V18.6334C24.7592 19.2174 27.4991 21.6673 27.4991 24.9992C27.4991 28.3311 24.7592 30.781 21.4993 31.365V31.999C21.4993 32.3968 21.3413 32.7783 21.06 33.0596C20.7787 33.3409 20.3972 33.4989 19.9993 33.4989C19.6015 33.4989 19.22 33.3409 18.9387 33.0596C18.6574 32.7783 18.4994 32.3968 18.4994 31.999V31.365C15.2395 30.781 12.4996 28.3311 12.4996 24.9992C12.4996 24.6014 12.6576 24.2199 12.9389 23.9386C13.2202 23.6573 13.6017 23.4992 13.9995 23.4992C14.3974 23.4992 14.7789 23.6573 15.0602 23.9386C15.3415 24.2199 15.4995 24.6014 15.4995 24.9992C15.4995 26.3551 16.6275 27.7931 18.4994 28.3031V21.3653C15.2395 20.7813 12.4996 18.3314 12.4996 14.9995C12.4996 11.6676 15.2395 9.2177 18.4994 8.63372V7.99974C18.4994 7.60193 18.6574 7.22041 18.9387 6.93911C19.22 6.65782 19.6015 6.49979 19.9993 6.49979Z",
    fill: "#1DE8DB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_8771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarDollarBold);
export default __webpack_public_path__ + "static/media/solar_dollar-bold.6bd3de9593eaee9901738dff682b1188.svg";
export { ForwardRef as ReactComponent };